import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';

interface MediaLoadingIndicatorProps {
  mediaLoadingState: 'notFetched' | 'loading' | 'loaded' | 'error';
}

export default function MediaLoadingIndicator({ mediaLoadingState }: MediaLoadingIndicatorProps) {
  const { t } = useTranslation(namespace);

  // Don't render anything for notFetched or loaded states
  if (mediaLoadingState === 'notFetched' || mediaLoadingState === 'loaded') {
    return null;
  }

  // Show loading state
  if (mediaLoadingState === 'loading') {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 2,
        color: 'var(--whatsapp-text)',
        opacity: 0.7
      }}>
        <CircularProgress size={20} sx={{ mr: 1 }} />
        <Typography sx={{ fontSize: '0.875rem' }}>
          {t('scheduledMessage.media.loading')}
        </Typography>
      </Box>
    );
  }

  // Show error state
  if (mediaLoadingState === 'error') {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 2,
        color: 'var(--whatsapp-text)',
        opacity: 0.7
      }}>
        <Typography sx={{ fontSize: '0.875rem' }}>
          {t('scheduledMessage.media.loadFailed')}
        </Typography>
      </Box>
    );
  }
}
